module.exports = __webpack_public_path__ + "static/laptop-3a0dd218b282abcdecf3ef86df727980.webp";